// | ------------------------------------------------------------------------
// | Product Grid
// | ------------------------------------------------------------------------ 


// Change layout between grid and list views
var productGridButton = document.querySelector(".product-grid-button");
var productListButton = document.querySelector(".product-list-button");

if(productListButton){

  var grid = document.querySelector(".product-grid");

  productListButton.addEventListener("click", function(){
    if(productListButton.classList.contains("active")){

    }else{
      productListButton.classList.add("active");
      grid.classList.add("list-grid");
      productGridButton.classList.remove("active");
    }

  })

  productGridButton.addEventListener("click", function(){
    if(productGridButton.classList.contains("active")){

    }else{
      productGridButton.classList.add("active");
      grid.classList.remove("list-grid");
      productListButton.classList.remove("active");
    }

  })  

}







